import React from "react";
import type { PropsWithChildren } from "react";

import styles from "./Icon.module.css";

export type IconProps = PropsWithChildren<{
  href: string;
  title?: string;
  size?: "small" | "medium" | "large" | "xlarge";
  filled?: boolean;
  className?: string;
  id?: string;
}>;

export function Icon({
  href,
  size = "medium",
  filled = false,
  title,
  className,
  id,
  ...props
}: IconProps) {
  const attrs: Record<string, string> = {};
  if (!title) {
    attrs.role = "presentation";
  }
  const classNames: string[] = [styles.Icon];
  if (size && size != "medium") {
    classNames.push(styles[`Icon--${size}`]);
  }
  if (filled) {
    classNames.push(styles["Icon--filled"]);
  }
  if (className) {
    classNames.push(className);
  }

  return (
    <svg
      viewBox="0 0 24 24"
      className={classNames.join(" ")}
      id={id}
      {...props}
      {...attrs}
    >
      {title && <title>{title}</title>}
      <use href={`${href}#icon`} />
    </svg>
  );
}

Icon.displayName = "Icon";
